<bz-dialog-layout [heading]="data.title"
                  [subheading]="'Admin Time' | translate"
                  [dismissible]="true">

  <div bzDialogContent class="layout-column timecard-dialog-body" appBringozIdGenerator="editAdminTimeDialog">

    <div class="timecard-dialog-row admin-time-header">
      <span class="admin-time-shift"></span>
      <span class="flex">{{ 'Hours' | translate }}</span>
      <span class="flex">{{ 'Minutes' | translate }}</span>
      <span class="admin-time-history"></span>
    </div>

    @for (row of rows(); track row.timeCardId; let index = $index) {
      <div class="timecard-dialog-row">
        <span class="admin-time-shift text-ellipsis" [class.admin-time-locked]="row.isLocked">{{ row.shiftName }}</span>
        <bz-input class="flex"
                  type="number"
                  size="sm"
                  placeholder="0"
                  [ariaLabel]="'Hours' | translate"
                  [value]="row.hours"
                  [disabled]="row.isLocked"
                  (focusin)="onFocusIn($event)"
                  (focusout)="onFocusOut(index, 'hours')"
                  (valueChange)="onValueChange(index, 'hours', $event)">
        </bz-input>
        <bz-input class="flex"
                  type="number"
                  size="sm"
                  placeholder="0"
                  [ariaLabel]="'Minutes' | translate"
                  [value]="row.minutes"
                  [disabled]="row.isLocked"
                  (focusin)="onFocusIn($event)"
                  (focusout)="onFocusOut(index, 'minutes')"
                  (valueChange)="onValueChange(index, 'minutes', $event)">
        </bz-input>
        <bz-button class="admin-time-history"
                   variant="tertiary"
                   size="fit"
                   [ariaLabel]="'History' | translate"
                   (clicked)="onOpenHistory(row)">
          <bz-icon [icon]="icons.history"></bz-icon>
        </bz-button>
      </div>
    }
  </div>

  <div bzDialogActions>
    <bz-button variant="tertiary" appBringozIdGenerator="cancelBtn" (clicked)="onCancel()">
      {{ 'Cancel' | translate }}
    </bz-button>
    <bz-button tone="secondary" appBringozIdGenerator="submitBtn" [disabled]="!changes().length" (clicked)="onSubmit()">
      {{ 'Submit' | translate }}
    </bz-button>
  </div>

</bz-dialog-layout>
